import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { Measure } from '../../../../models/measure';
import {
  selectMeasure
} from '../../../../features/measure/measure.actions';
import { EmergencyTools } from '../../../../tools/emergency.tools';
import { selectUser } from '../../../../features/user/user.selectors';
import { Observable } from 'rxjs';
import {
  selectMeasureById
} from '../../../../features/measure/measure.selectors';

@Component({
    selector: 'measure-card',
    templateUrl: './measure-card.component.html',
    styleUrls: ['../card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class MeasureCardComponent {

  private _measureId!: string;

  @Input({ required: true })
  set measureId(value: string) {
    this._measureId = value;
    this.measure$ = this.store.select(selectMeasureById(value));
  }
  measure$!: Observable<Measure | undefined>;
  readonly currentUser$ = this.store.select(selectUser);
  readonly border = '2px solid #000000';

  constructor(private store: Store) {
  }

  onClickEdit(measure: Measure): void {
    this.store.dispatch(selectMeasure({id: measure.id}));
  }
}
